import { render, staticRenderFns } from "./CompositeOrder.vue?vue&type=template&id=2f560083&scoped=true"
import script from "./CompositeOrder.vue?vue&type=script&lang=js"
export * from "./CompositeOrder.vue?vue&type=script&lang=js"
import style0 from "./CompositeOrder.vue?vue&type=style&index=0&id=2f560083&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f560083",
  null
  
)

export default component.exports